import { fraction, Fraction } from 'mathjs';
import * as math from "mathjs";

export const GRID_MEASURE_LEN = 192;
export const NUM_MEASURE = 16;

export const NOTE_HEIGHT = 10;
export const SNAP_DISTANCE = 96;
export const PRELOAD_LEN = 0.25;
export const ZOOM_STEP = 0.25;

export const GRID_EDIT_DIV = 16;
export const GRID_SUB_DIV = 4;

export const LANE_WIDTH = 28;
export const LANE_SEPARATER_WIDTH = 50; //4;
export const LANE_LEFT = 35;

export const NUM_KEY_LANES = 8;
export const NUM_BGM_LANES = 16; // TODO: Stateに入れる

interface LaneInfo {
  className: string,
  left: number,
  width: number,
  index: number
}

export const keyLaneInfo: LaneInfo[] = (() => {
  const KEY_LANE_CLASSES = [
    'lane-sc',
    'lane-w',
    'lane-b',
    'lane-w',
    'lane-b',
    'lane-w',
    'lane-b',
    'lane-w',
  ];

  let lanes = [] as LaneInfo[];
  let left = LANE_LEFT;

  for (let i = 0; i < KEY_LANE_CLASSES.length; i++) {
    lanes.push({ className: KEY_LANE_CLASSES[i], left, width: LANE_WIDTH, index: i });
    left += LANE_WIDTH;
  }

  return lanes;
})();

export const trackLaneInfo: LaneInfo[] = (() => {
  let lanes = [] as LaneInfo[];

  const lastLaneInfo = keyLaneInfo[keyLaneInfo.length - 1];
  let left = lastLaneInfo.left + lastLaneInfo.width;

  left += LANE_SEPARATER_WIDTH;

  for (let i = 0; i < NUM_BGM_LANES; i++) {
    lanes.push({ className: 'lane-track', left, width: LANE_WIDTH, index: i });
    left += LANE_WIDTH;
  }

  return lanes;
})();

export function keyLaneToX(lane: number): number {
  return keyLaneInfo[0].left + lane * LANE_WIDTH + 1;
}

export function xToKeyLane(x: number): number | null {
  const lane = Math.floor((x - keyLaneInfo[0].left) / LANE_WIDTH);
  if (lane < 0 || lane >= keyLaneInfo.length) return null;
  return lane;
}

export function trackLaneToX(lane: number): number {
  return trackLaneInfo[0].left + lane * LANE_WIDTH + 1;
}

export function xToTrackLane(x: number): number | null {
  const lane = Math.floor((x - trackLaneInfo[0].left) / LANE_WIDTH);
  if (lane < 0 || lane >= trackLaneInfo.length) return null;
  return lane;
}

export function timePosToY(timePos: Fraction, zoom: number): number {
  return Math.ceil(GRID_MEASURE_LEN * (NUM_MEASURE - (math.number(timePos) as number)) * zoom);
}

export function yToTimePos(y: number, zoom: number): Fraction {
  const timePos = math.subtract(NUM_MEASURE, fraction(y / zoom, GRID_MEASURE_LEN)) as Fraction;
  if (math.smaller(timePos, 0)) return fraction(0) as Fraction;
  return timePos;
}

export function trackHue(i: number) {
  return i * 360 / NUM_BGM_LANES;
}

export const trackNames = [
  'BD',
  'CP',
  'SD',
  'HH',
  'RD',
  'CY',
  'Break',
  'Fill',
  'Lead',
  'Bell',
  'Piano',
  'Arp',
  'Chord',
  'Bass',
  'Pad',
  'Fx'
];
